import React, { useState, useEffect } from 'react';
import styles from '../../styles/AsignacionBecasStyles/AsignacionBecas.module.css';
import programasStyles from '../../styles/PantallaDeProgramasAcademicos.v2.module.css';
import estudiantesStyles from '../../styles/EstudiantesStyles/Estudiantes.module.css';
import { getCampus } from '../../api/campus';
import { getCycles } from '../../api/ciclosEscolares';

function SearchFilters({ selectedCampus, setSelectedCampus, selectedCiclo, setSelectedCiclo, searchTerm, setSearchTerm, onSearch }) {
  const [campusList, setCampusList] = useState([]);
  const [ciclosList, setCiclosList] = useState([]);

  useEffect(() => {
    loadDropdowns();
  }, []);

  const loadDropdowns = async () => {
    try {
      const [campusData, ciclosData] = await Promise.all([
        getCampus(),
        getCycles()
      ]);

      setCampusList(campusData || []);
      setCiclosList(ciclosData || []);
      
      // Establecer ciclo más reciente como default
      if (ciclosData && ciclosData.length > 0) {
        // Backend devuelve ciclos ordenados DESC (2026-2, 2026-1, etc)
        const cicloMasReciente = ciclosData[0];
        setSelectedCiclo(cicloMasReciente.id || cicloMasReciente.id_ciclo_escolar);
      }
    } catch (error) {
      console.error('Error al cargar dropdowns:', error);
    }
  };

  return (
    <div className={estudiantesStyles.searchSection}>
      <div className={estudiantesStyles.searchCard}>
        <div className={estudiantesStyles.searchRow}>
          {/* Campus */}
          <div className={estudiantesStyles.formGroup}>
            <label className={estudiantesStyles.searchLabel}>Campus</label>
            <select 
              className={estudiantesStyles.searchSelect}
              value={selectedCampus}
              onChange={(e) => setSelectedCampus(e.target.value)}
            >
              <option key="main-campus-all" value="">Todos los campus</option>
              {campusList.map((campus) => (
                <option key={`main-campus-${campus.id || campus.id_campus}`} value={campus.id || campus.id_campus}>
                  {campus.nombre || campus.nombre_campus}
                </option>
              ))}
            </select>
          </div>
          {/* Buscador */}
          <div className={estudiantesStyles.searchInputGroup}>
            <svg
              className={estudiantesStyles.searchIcon}
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M21 21L15 15M17 10C17 13.866 13.866 17 10 17C6.13401 17 3 13.866 3 10C3 6.13401 6.13401 3 10 3C13.866 3 17 6.13401 17 10Z"
                stroke="#898d8d"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
            <input
              type="text"
              className={estudiantesStyles.searchInput}
              placeholder="Buscar Estudiante por Matrícula o Nombre"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              onKeyPress={e => { if (e.key === 'Enter') onSearch(); }}
            />
          </div>
          {/* Botón BUSCAR */}
          <button className={programasStyles.buscarButtonProgramas} onClick={onSearch}>
            Buscar
          </button>
          {/* Ciclo Escolar */}
          <div className={estudiantesStyles.formGroup}>
            <label className={estudiantesStyles.searchLabel}>Ciclo Escolar</label>
            <select 
              className={estudiantesStyles.searchSelect}
              value={selectedCiclo}
              onChange={(e) => setSelectedCiclo(e.target.value)}
            >
              <option key="main-ciclo-all" value="">Todos los ciclos</option>
              {[...ciclosList].sort((a, b) => {
                const yearA = Number(a.anio || 0);
                const yearB = Number(b.anio || 0);
                if (yearA !== yearB) return yearB - yearA;
                const periodA = Number(a.numero_periodo || 0);
                const periodB = Number(b.numero_periodo || 0);
                return periodB - periodA;
              }).map((ciclo) => (
                <option key={`main-ciclo-${ciclo.id || ciclo.id_ciclo_escolar}`} value={ciclo.id || ciclo.id_ciclo_escolar}>
                  {ciclo.name || ciclo.nombre || ciclo.nombre_ciclo}
                </option>
              ))}
            </select>
          </div>
        </div>
      </div>
    </div>
  );
}

export default SearchFilters;
